import { render, staticRenderFns } from "./AddTaskStep.vue?vue&type=template&id=634914f4&scoped=true&"
import script from "./AddTaskStep.vue?vue&type=script&lang=js&"
export * from "./AddTaskStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634914f4",
  null
  
)

export default component.exports